<div>
  <div class="header-style">
    <div class="h-100">
      @if (user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) {
        <mat-form-field appearance="outline" class="select">
          <mat-select data-testid="usedOnMobile_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #usedOnMobile_filter  id="usedOnMobile_filter"
            name="usedOnMobile_filter">
            <mat-option i18n="@@CertificatesUsedonmobile" value="usedOnMobile">Certificates Used on mobile</mat-option>
            <mat-option i18n="@@CertificatesToPickFrom" value="manufacturer">Certificates To Pick From</mat-option>
            <mat-option i18n="@@ExpiredCertificates" value="expired">Expired Certificates</mat-option>
          </mat-select>
        </mat-form-field>
      }
    </div>

    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>

      <mat-icon data-testid="add_certificate_button" (click)="openAddCertificate()" class="cursor add-icon" svgIcon="add" aria-hidden="false" i18n-aria-label aria-label="Add Certificate"></mat-icon>

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input data-testid="certificate_search_input" i18n-placeholder="@@searchPlaceholder" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="certificate_clear_button" class="cursor" matSuffix (click)="clearSearch()" i18n-aria-label aria-label="Clear search">clear</mat-icon>
          </mat-form-field>
        }
      </form>

      <mat-icon data-testid="certificate_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-aria-label aria-label="Search"></mat-icon>
    </div>
  </div>

  @for (item of certificatesList; track item; let itemIndex = $index) {
    <mat-card class="{{(itemIndex % 2 === 0 ? 'lite-box-without-img mr-16 ' : 'lite-box-without-img')}}">
      <mat-card-content class="content-box">
        <div class="cursor" (click)="openCertificateDetails(item.id)">
          <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.description}}</div>
          <div class="mat-caption" matTooltip ellipsisTooltip>{{item.expirationDate}}</div>
        </div>

        @if (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild) {
          <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label aria-label="More options">more_vert</mat-icon>
        }

        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'manufacturer') {
          <mat-icon class="{{item.usedOnMobile ? 'cursor header-icon' : 'header-icon-color cursor'}}" (click)="item.usedOnMobile ? moveToNotUsedOnMobile(item.id) : moveToUsedOnMobile(item.id)" i18n-aria-label aria-label="Toggle used on mobile">stay_current_portrait</mat-icon>
        }

        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === false) {
          <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label aria-label="More options">more_vert</mat-icon>
        }

        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'expired' && item.isAddedByManufacturer === false) {
          <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label aria-label="More options">more_vert</mat-icon>
        }

        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === true) {
          <mat-icon class="cursor header-icon" (click)="moveToNotUsedOnMobile(item.id)" i18n-aria-label aria-label="Move to not used on mobile">stay_current_portrait</mat-icon>
        }

        <mat-menu #menu="matMenu">
          <button i18n="@@edit" data-testid="edit_certificate" (click)="openEditCertificate(item.id, item)" mat-menu-item>Edit</button>
          <button i18n="@@delete" data-testid="delete_certificate" (click)="deleteCertificate(item.id)" mat-menu-item>Delete</button>
        </mat-menu>
      </mat-card-content>
    </mat-card>
  }

  @if (certificatesList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-aria-label aria-label="No certificates available">
  }
</div>